/**
 * @file Displays customer information.
 */
import React from 'react';
import { Customer } from '../models/types';

interface CustomerInfoProps {
  customer: Customer;
}

const CustomerInfo: React.FC<CustomerInfoProps> = ({ customer }) => {
    return (
        <div className="customer-info">
            <h3>Información del Cliente</h3>
            <div className="customer-details">
                <p><strong>Nombre:</strong> {customer.name}</p>
                {customer.phoneNumber && (
                    <p><strong>Teléfono:</strong> {customer.phoneNumber}</p>
                )}
                {customer.whatsappNumber && (
                    <p><strong>WhatsApp:</strong> {customer.whatsappNumber}</p>
                )}
                {customer.facebookName && (
                    <p><strong>Facebook:</strong> {customer.facebookName}</p>
                )}
                {customer.wazeUrl && (
                    <p><strong>Waze:</strong> <a href={customer.wazeUrl} target="_blank" rel="noopener noreferrer">Abrir en Waze</a></p>
                )}
            </div>
        </div>
    );
};

export default CustomerInfo;
